import Vue from "vue";

export default {
  data() {
    return {
      questionList: [],
      userAnswerList: [],
      currentQuestionIdx: 0,
      currentQuestion: {},
      showAnswerSheet: false,
      curAnswer: "" // 当前问题的标准答案，自己组装的，格式：A、B
    };
  },
  created: function() {
    this.loadQuestionList();
  },
  methods: {
    // 加载当前问题的统一方法
    renderQuestion() {
      this.currentQuestion = this.questionList[this.currentQuestionIdx];

      // 计算要显示的标准答案部分
      this.curAnswer = "";
      this.currentQuestion.optionList.forEach(option => {
        if (option.isCorrect) {
          if (this.curAnswer !== "") {
            this.curAnswer += "、";
          }
          this.curAnswer += option.sort;
        }
      });
    },
    async loadQuestionList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      // 根据传进来的peId获取该试卷中所有问题及解析
      // eslint-disable-next-line prefer-const
      this.userAnswerList = this.$route.query.userAnswerList; // 上一个页面传过来的用户的答案，格式为：[{ptqrId: 123, answer: "A,B", eqId: 8}]
      // eslint-disable-next-line prefer-const
      this.questionList = this.$route.query.userAnswerResultList; // 上一个页面传过来的用户答案正确与否，格式为：[{ptqrId: 123, isCorrect: true}]

      // 如果当前是只看错题的模式，则将正确的题目、用户答案均剔除掉
      if (this.$route.query.isWrongMode) {
        // eslint-disable-next-line prefer-const
        let tempQuestionList = [];
        // eslint-disable-next-line prefer-const
        let tempUserAnswerList = [];
        // eslint-disable-next-line prefer-const
        let tempUserAnswerResultList = [];
        for (let idx = 0; idx < this.questionList.length; idx++) {
          if (this.questionList[idx].isCorrect === false) {
            // 将这个错误的问题保存起来
            tempQuestionList.push(this.questionList[idx]);
            tempUserAnswerList.push(this.userAnswerList[idx]);
            tempUserAnswerResultList.push(this.questionList[idx]);
          }
        }
        // 最后把错题更新到正式的列表里
        this.questionList = tempQuestionList;
        this.userAnswerList = tempUserAnswerList;
        this.questionList = tempUserAnswerResultList;
      }

      // 设置用户每道题每个选项是否选中，设置每道题用户是否答对了
      for (
        let curQueIdx = 0;
        curQueIdx < this.questionList.length;
        curQueIdx++
      ) {
        const curQueUserAnswer = this.userAnswerList[curQueIdx];
        const curQueUserAnswerList = curQueUserAnswer["answer"].split(",");
        // 循环当前问题的每一个选项，判断用户是否已经选中了
        for (
          let optIdx = 0;
          optIdx < this.questionList[curQueIdx].optionList.length;
          optIdx++
        ) {
          let exist = false;
          for (
            let userAnswerIdx = 0;
            userAnswerIdx < curQueUserAnswerList.length;
            userAnswerIdx++
          ) {
            if (
              curQueUserAnswerList[userAnswerIdx] ===
              this.questionList[curQueIdx].optionList[optIdx]["sort"]
            ) {
              // 存在，也就是用户选择了
              exist = true;
              break;
            }
          }
          // 设置当前选项是否被用户选择了
          Vue.set(
            this.questionList[curQueIdx].optionList[optIdx],
            "isSelected",
            exist
          );
        }
      }
      this.renderQuestion();
      loadingInstance.close();
    },
    // 上一题
    previous_question() {
      if (this.currentQuestionIdx > 0) {
        this.currentQuestionIdx--;
        this.renderQuestion();
      }
    },
    // 下一题
    next_question() {
      if (this.currentQuestionIdx < this.questionList.length - 1) {
        this.currentQuestionIdx++;
        this.renderQuestion();
      }
    },
    // 跳到指定问题
    jump2Question(index) {
      this.currentQuestionIdx = index;
      this.renderQuestion();
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
